export const style = (...atoms) => atoms
    .map((_) => isStyleRecord(_)
    ? Object.entries(_)
        .filter(([, v]) => v)
        .map(([k]) => k)
    : _)
    .flatMap((_) => _)
    .filter(Boolean)
    .join(' ');
const isStyleRecord = (_) => Boolean(_ && typeof _ === 'object' && !Array.isArray(_));
//# sourceMappingURL=style.js.map